import * as collapsible from "@zag-js/collapsible"
import {normalizeProps, useMachine} from "@zag-js/solid"
import {createMemo, createUniqueId, JSX, splitProps} from "solid-js"


export interface CollapsibleProps extends Partial<collapsible.Props> {
    children: (api: collapsible.Api) => JSX.Element;
}

export default function Collapsible(props: CollapsibleProps) {
    const [_, machineProps] = splitProps(props, ["children"])
    const service = useMachine(collapsible.machine, {id: createUniqueId(), ...machineProps})
    const api = createMemo(() => collapsible.connect(service, normalizeProps))
    return <props.children {...api()}/>
}